import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between px-6 py-2 bg-white border-b-4" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = {
  key: 0,
  class: "absolute -top-1 -right-1 bg-red-600 text-white text-xs font-semibold w-5 h-5 flex items-center justify-center rounded-full animate-pulse"
}
const _hoisted_7 = { class: "fixed sm:absolute right-0 sm:right-0 top-0 sm:top-auto sm:mt-2 w-full sm:w-96 h-full sm:h-auto bg-white rounded-none sm:rounded-lg shadow-xl z-20 border-0 sm:border border-gray-200 max-h-full sm:max-h-[28rem] overflow-hidden flex flex-col" }
const _hoisted_8 = { class: "flex items-center justify-between px-4 py-3 sm:py-3 border-b bg-gradient-to-r from-indigo-50 to-purple-50" }
const _hoisted_9 = { class: "text-xs text-gray-600" }
const _hoisted_10 = { class: "flex gap-2" }
const _hoisted_11 = { class: "overflow-y-auto flex-1 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 hover:scrollbar-thumb-gray-400" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 0,
  class: "absolute left-0 top-0 bottom-0 w-1 bg-indigo-600"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "flex-1 min-w-0 pr-2" }
const _hoisted_16 = { class: "text-sm sm:text-sm text-gray-800 leading-relaxed" }
const _hoisted_17 = { class: "font-bold" }
const _hoisted_18 = { class: "text-xs text-gray-500 mt-1.5" }
const _hoisted_19 = { class: "flex items-center gap-1 ml-2 sm:opacity-0 sm:group-hover:opacity-100 transition-opacity flex-shrink-0" }
const _hoisted_20 = ["onClick", "title"]
const _hoisted_21 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-4 w-4",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_22 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-4 w-4",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 1,
  class: "px-4 py-16 sm:py-12 text-center"
}
const _hoisted_25 = { class: "relative" }
const _hoisted_26 = { class: "hidden md:block text-left" }
const _hoisted_27 = { class: "text-sm font-medium text-gray-700" }
const _hoisted_28 = { class: "text-xs text-gray-500" }
const _hoisted_29 = { class: "absolute right-0 z-20 w-64 mt-3 bg-white rounded-xl shadow-2xl border border-gray-200 overflow-hidden" }
const _hoisted_30 = { class: "px-4 py-3 bg-gradient-to-r from-indigo-50 to-purple-50 border-b border-gray-200" }
const _hoisted_31 = { class: "flex items-center gap-3" }
const _hoisted_32 = { class: "flex-1 min-w-0" }
const _hoisted_33 = { class: "text-sm font-semibold text-gray-900 truncate" }
const _hoisted_34 = { class: "text-xs font-semibold text-gray-900 truncate" }
const _hoisted_35 = { class: "text-xs text-gray-600 truncate" }
const _hoisted_36 = { class: "py-2" }

import { computed, ref } from "vue";
import { useSidebar } from "../../hooks/useSidebar";
import { useAuthStore } from "@/stores/authStore";
import { useNotificationStore } from "@/stores/notificationStore";
import ModelDetallePedido from "./ModelDetallePedido.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

const dropdownOpen = ref(false);
const notificationOpen = ref(false);

// 🆕 Estado del modal
const modalOpen = ref(false);
const selectedPedidoId = ref<string | null>(null);

const { isOpen } = useSidebar();
const authStore = useAuthStore();
const user = authStore.user;

// 🔔 Notification store
const notificationStore = useNotificationStore();
const notifications = computed(() => notificationStore.notifications);
const unreadCount = computed(() => 
  notifications.value.filter(n => !n.read).length
);

async function LogOut() {
  await authStore.logout();
}

function markAsRead(notificationId: number) {
  notificationStore.markAsRead(notificationId);
}

function deleteNotification(notificationId: number) {
  notificationStore.deleteNotification(notificationId);
}

function clearAllNotifications() {
  notificationStore.clearAll();
}

function markAllAsRead() {
  notificationStore.markAllAsRead();
}

// 🆕 Función actualizada: abrir modal en lugar de navegar
function openPedidoModal(notification: any) {
  // Marcar como leída
  if (!notification.read) {
    markAsRead(notification.id);
  }
  
  // Cerrar el dropdown de notificaciones
  notificationOpen.value = false;
  
  // Abrir el modal con el ID del pedido
  if (notification.idPedido) {
    selectedPedidoId.value = notification.idPedido.toString();
    modalOpen.value = true;
  }
}

// 🆕 Cerrar modal
function closeModal() {
  modalOpen.value = false;
  selectedPedidoId.value = null;
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = true)),
          class: "text-gray-500 focus:outline-none lg:hidden"
        }, [...(_cache[7] || (_cache[7] = [
          _createElementVNode("svg", {
            class: "w-6 h-6",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("path", {
              d: "M4 6H20M4 12H20M4 18H11",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            })
          ], -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (notificationOpen.value = !notificationOpen.value)),
              class: "flex mx-4 text-gray-600 focus:outline-none relative hover:text-blue-400 transition-colors"
            }, [
              _cache[8] || (_cache[8] = _createElementVNode("svg", {
                class: "h-6 w-6",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  d: "M15 17H20L18.5951 15.5951C18.2141 15.2141 18 14.6973 18 14.1585V11C18 8.38757 16.3304 6.16509 14 5.34142V5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5V5.34142C7.66962 6.16509 6 8.38757 6 11V14.1585C6 14.6973 5.78595 15.2141 5.40493 15.5951L4 17H9M15 17V18C15 19.6569 13.6569 21 12 21C10.3431 21 9 19.6569 9 18V17M15 17H9",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                })
              ], -1)),
              (unreadCount.value > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(unreadCount.value), 1))
                : _createCommentVNode("", true)
            ]),
            _withDirectives(_createElementVNode("div", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (notificationOpen.value = false)),
              class: "fixed inset-0 h-full w-full z-10"
            }, null, 512), [
              [_vShow, notificationOpen.value]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (notificationOpen.value = false)),
                  class: "sm:hidden p-1 hover:bg-white/50 rounded-lg transition-colors"
                }, [...(_cache[9] || (_cache[9] = [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    class: "h-6 w-6 text-gray-600",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ]))]),
                _createElementVNode("div", null, [
                  _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-sm sm:text-sm font-semibold text-gray-800" }, "Notificaciones", -1)),
                  _createElementVNode("p", _hoisted_9, _toDisplayString(unreadCount.value) + " sin leer", 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  (notifications.value.length > 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: markAllAsRead,
                        class: "text-xs text-indigo-600 hover:text-indigo-800 font-medium transition-colors p-1",
                        title: "Marcar todas como leídas"
                      }, [...(_cache[11] || (_cache[11] = [
                        _createElementVNode("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          class: "h-5 w-5",
                          fill: "none",
                          viewBox: "0 0 24 24",
                          stroke: "currentColor"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M5 13l4 4L19 7"
                          })
                        ], -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  (notifications.value.length > 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: clearAllNotifications,
                        class: "text-xs text-red-600 hover:text-red-800 font-medium transition-colors p-1",
                        title: "Limpiar todas"
                      }, [...(_cache[12] || (_cache[12] = [
                        _createElementVNode("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          class: "h-5 w-5",
                          fill: "none",
                          viewBox: "0 0 24 24",
                          stroke: "currentColor"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                          })
                        ], -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                (notifications.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notifications.value, (n) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: n.id,
                          class: _normalizeClass(["group relative border-b last:border-b-0 transition-colors", n.read ? 'bg-white' : 'bg-indigo-50/50'])
                        }, [
                          (!n.read)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            class: _normalizeClass(["flex items-start px-3 sm:px-4 py-3 sm:py-3 hover:bg-gray-50 cursor-pointer transition-colors", n.read ? '' : 'pl-4 sm:pl-5']),
                            onClick: ($event: any) => (openPedidoModal(n))
                          }, [
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("p", _hoisted_16, [
                                _createElementVNode("span", _hoisted_17, _toDisplayString(n.cliente), 1),
                                _cache[13] || (_cache[13] = _createTextVNode(" hizo un pedido ", -1))
                              ]),
                              _createElementVNode("p", _hoisted_18, _toDisplayString(new Date(n.fecha ?? 0).toLocaleString()), 1),
                              _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-xs text-blue-400 mt-1 opacity-0 group-hover:opacity-100 transition-opacity flex items-center gap-1" }, [
                                _createElementVNode("span", null, "Click para ver detalles"),
                                _createElementVNode("svg", {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  class: "h-3 w-3",
                                  fill: "none",
                                  viewBox: "0 0 24 24",
                                  stroke: "currentColor"
                                }, [
                                  _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "stroke-width": "2",
                                    d: "M9 5l7 7-7 7"
                                  })
                                ])
                              ], -1))
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("button", {
                                onClick: _withModifiers(($event: any) => (markAsRead(n.id)), ["stop"]),
                                class: _normalizeClass(["p-1.5 sm:p-1.5 rounded-md transition-colors", n.read 
                          ? 'text-gray-400 hover:text-indigo-600 hover:bg-indigo-50' 
                          : 'text-indigo-600 hover:text-indigo-800 hover:bg-indigo-100']),
                                title: n.read ? 'Marcar como no leída' : 'Marcar como leída'
                              }, [
                                (!n.read)
                                  ? (_openBlock(), _createElementBlock("svg", _hoisted_21, [...(_cache[15] || (_cache[15] = [
                                      _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                      }, null, -1)
                                    ]))]))
                                  : (_openBlock(), _createElementBlock("svg", _hoisted_22, [...(_cache[16] || (_cache[16] = [
                                      _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M8 12h.01M12 12h.01M16 12h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                      }, null, -1)
                                    ]))]))
                              ], 10, _hoisted_20),
                              _createElementVNode("button", {
                                onClick: _withModifiers(($event: any) => (deleteNotification(n.id)), ["stop"]),
                                class: "p-1.5 sm:p-1.5 text-red-600 hover:text-red-800 hover:bg-red-50 rounded-md transition-colors",
                                title: "Eliminar notificación"
                              }, [...(_cache[17] || (_cache[17] = [
                                _createElementVNode("svg", {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  class: "h-4 w-4",
                                  fill: "none",
                                  viewBox: "0 0 24 24",
                                  stroke: "currentColor"
                                }, [
                                  _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "stroke-width": "2",
                                    d: "M6 18L18 6M6 6l12 12"
                                  })
                                ], -1)
                              ]))], 8, _hoisted_23)
                            ])
                          ], 10, _hoisted_14)
                        ], 2))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_24, [...(_cache[18] || (_cache[18] = [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        class: "h-20 w-20 sm:h-16 sm:w-16 mx-auto text-gray-300 mb-4 sm:mb-3",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                        })
                      ], -1),
                      _createElementVNode("p", { class: "text-gray-500 text-sm font-medium" }, "No hay notificaciones", -1),
                      _createElementVNode("p", { class: "text-gray-400 text-xs mt-1" }, "Te notificaremos cuando llegue algo nuevo", -1)
                    ]))]))
              ])
            ], 512), [
              [_vShow, notificationOpen.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (dropdownOpen.value = !dropdownOpen.value)),
            class: "flex items-center gap-2 p-1.5 rounded-lg hover:bg-gray-100 transition-all duration-200 group"
          }, [
            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "relative" }, [
              _createElementVNode("img", {
                class: "w-9 h-9 rounded-full object-cover ring-2 ring-gray-200 group-hover:ring-blue-400 transition-all duration-200",
                src: "https://images.unsplash.com/photo-1528892952291-009c663ce843?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=296&q=80",
                alt: "Your avatar"
              })
            ], -1)),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(user)?.firstName), 1),
              _createElementVNode("p", _hoisted_28, _toDisplayString(_unref(user)?.authUserRoles?.[0]?.authRoles?.name ?? ""), 1)
            ]),
            (_openBlock(), _createElementBlock("svg", {
              class: _normalizeClass(["hidden md:block w-4 h-4 text-gray-400 transition-transform duration-200", { 'rotate-180': dropdownOpen.value }]),
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [...(_cache[19] || (_cache[19] = [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M19 9l-7 7-7-7"
              }, null, -1)
            ]))], 2))
          ]),
          _withDirectives(_createElementVNode("div", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (dropdownOpen.value = false)),
            class: "fixed inset-0 z-10"
          }, null, 512), [
            [_vShow, dropdownOpen.value]
          ]),
          _createVNode(_Transition, {
            "enter-active-class": "transition duration-200 ease-out transform",
            "enter-from-class": "scale-95 opacity-0",
            "enter-to-class": "scale-100 opacity-100",
            "leave-active-class": "transition duration-150 ease-in transform",
            "leave-from-class": "scale-100 opacity-100",
            "leave-to-class": "scale-95 opacity-0"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _cache[21] || (_cache[21] = _createElementVNode("img", {
                      class: "w-12 h-12 rounded-full object-cover ring-2 ring-white shadow-sm",
                      src: "https://images.unsplash.com/photo-1528892952291-009c663ce843?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=296&q=80",
                      alt: "Profile"
                    }, null, -1)),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("p", _hoisted_33, _toDisplayString(_unref(user)?.firstName), 1),
                      _createElementVNode("p", _hoisted_34, _toDisplayString(_unref(user)?.lastName), 1),
                      _createElementVNode("p", _hoisted_35, _toDisplayString(_unref(user)?.email), 1)
                    ])
                  ])
                ]),
                _cache[23] || (_cache[23] = _createElementVNode("div", { class: "border-t border-gray-200" }, null, -1)),
                _createElementVNode("div", _hoisted_36, [
                  _createVNode(_component_router_link, {
                    to: "/",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (LogOut())),
                    class: "flex items-center gap-3 px-4 py-2.5 text-sm text-red-600 hover:bg-red-50 transition-colors group"
                  }, {
                    default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                      _createElementVNode("div", { class: "w-9 h-9 rounded-lg bg-red-50 group-hover:bg-red-100 flex items-center justify-center transition-colors" }, [
                        _createElementVNode("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          class: "w-5 h-5 text-red-600",
                          fill: "none",
                          viewBox: "0 0 24 24",
                          stroke: "currentColor",
                          "stroke-width": "2"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                          })
                        ])
                      ], -1),
                      _createElementVNode("div", { class: "flex-1" }, [
                        _createElementVNode("p", { class: "font-medium" }, "Log out"),
                        _createElementVNode("p", { class: "text-xs text-red-500" }, "Sign out of your account")
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ])
              ], 512), [
                [_vShow, dropdownOpen.value]
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(ModelDetallePedido, {
      "is-open": modalOpen.value,
      "pedido-id": selectedPedidoId.value,
      onClose: closeModal
    }, null, 8, ["is-open", "pedido-id"])
  ], 64))
}
}

})